import { Component } from '@angular/core';
import { Observable, combineLatest, map } from 'rxjs';
import { ProductService } from 'src/app/services/product.service';
import { Drink } from 'src/interfaces/drink.model';
import { Food } from 'src/interfaces/food.model';

/**
 * «Есть аллергия или непереносимость? Сообщите официанту перед заказом» — вверху
 * меню и в корзине. Только если в меню указаны аллергены (у блюд, напитков или
 * их добавок): заведения без аллергенов меню не меняют
 */
@Component({
    selector: 'app-allergy-notice',
    templateUrl: './menu-allergy-notice.component.html',
    styleUrls: ['./menu-allergy-notice.component.css'],
    standalone: false
})
export class MenuAllergyNoticeComponent {
  visible$: Observable<boolean>;

  constructor(productService: ProductService) {
    this.visible$ = combineLatest([productService.foods$, productService.drinks$]).pipe(
      map(([foods, drinks]) => [...foods, ...drinks].some(hasAllergens)),
    );
  }
}

export function hasAllergens(item: Food | Drink): boolean {
  if (item.allergens?.length) return true;
  const modificators = typeof item.modificators === 'object' ? item.modificators : undefined;
  return !!modificators?.items?.some((m) => m.allergens?.length);
}
